export default "__VITE_ASSET__781ba915__"